const app = {
  state: {
    leave: false,
    gameList: {}, //游戏列表
    forward: "", //跳转外部链接
    headerShow: false, //公共头部列表显示与隐藏
    commonInfo: {} // 一些公共信息
  },
  mutations: {
    //设置外部链接
    SET_FORWARD: (state, url) => {
      state.forward = url;
    },
    //设置公共信息
    SET_COMMON_INFO: (state, data) => {
      state.commonInfo = data;
    },
    //设置展示公共头部的显示与隐藏
    SET_HEADER_SHOW: (state, headerShow) => {
      state.headerShow = headerShow;
    },
    //设置游戏列表
    SET_GAME_LIST: (state, gameList) => {
      if (gameList && gameList.length > 0) {
        let gameObj = {};
        gameList.forEach(el => {
          if (el.game_id) {
            gameObj = { ...gameObj, [el.game_id]: el };
          }
        });
        state.gameList = gameObj;
      }
    },
    //设置页面离开标识
    SET_LEAVE: (state, leave) => {
      state.leave = leave;
    }
  },
  actions: {
    SetCommonInfo({ commit }, data) {
      if (data && Object.keys(data).length > 0) {
        commit("SET_COMMON_INFO", data);
        commit("SET_GAME_LIST", data["jzyx_base_game"] || []);
      }
    },
    SetHeaderShow({ commit }, headerShow) {
      commit("SET_HEADER_SHOW", headerShow);
    },
    SetLeave({ commit }, leave) {
      commit("SET_LEAVE", leave);
    }
  }
};

export default app;
